import { stepDirFromPath } from "../../shared/stepConfig";

type CommitFile = { path: string; blobHash: string };

/**
 * Compare fork-point files against head-commit files and return the set of
 * step directory names that have changed (added or modified blobs).
 */
export function computeChangedStepDirs(
  forkFiles: readonly CommitFile[],
  headFiles: readonly CommitFile[]
): Set<string> {
  const changed = new Set<string>();
  if (forkFiles.length === 0) return changed;
  const forkByPath = new Map(forkFiles.map((f) => [f.path, f.blobHash]));
  for (const f of headFiles) {
    const forkHash = forkByPath.get(f.path);
    if (forkHash == null || forkHash !== f.blobHash) {
      const dir = stepDirFromPath(f.path);
      if (dir) changed.add(dir);
    }
  }
  return changed;
}
